<template>
  <!-- 客户端下载落地页 -->
  <div class="clientLanding">
    <!-- 顶部栏 -->
    <div class="topBar">
      <div class="barL">
        <div class="barIcon">
          <img :src="gameData.icon" alt />
        </div>
        <div class="bartitle">
          <p>{{ gameData.title }}</p>
          <p>{{ gameData.summary }}</p>
        </div>
      </div>
      <div class="barR" >
        <p>
          <!-- <a @click.prevent="jumpDownGame()">点击下载</a> -->
          <a @click.stop="lyDownGame(2, btn_list.az)" v-show="!iosSystem && btn_list.az.display"></a>
          <a  @click.stop="lyDownGame(3, btn_list.h5)" v-show="btn_list.h5.display"></a>
          <a @click.stop="lyDownGame(1, btn_list.ios)" v-show="iosSystem && btn_list.ios.display"></a>
        </p>
      </div>
    </div>
    <div class="bg-img">
      <img :src="gameData.bg" alt="落地页" />
      <!-- 下载游戏 -->
      <div
        class="downGame"
        ref="downGame"
        v-if="Object.keys(btn_list).length !== 0"
        :class="isPcDown ? 'pcDownGame' : ''"
      >
        <div
          class="system android"
          @click.stop="lyDownGame(2, btn_list.az)"
          v-show="!iosSystem && btn_list.az.display"
        >
          <img :src="btn_list.az.btn_bg" alt />
        </div>
        <div
          class="system h5"
          @click.stop="lyDownGame(3, btn_list.h5)"
          v-show="btn_list.h5.display"
        >
          <img :src="btn_list.h5.btn_bg" alt />
        </div>
        <div
          class="system ios"
          @click.stop="lyDownGame(1, btn_list.ios)"
          v-show="iosSystem && btn_list.ios.display"
        >
          <img :src="btn_list.ios.btn_bg" alt />
        </div>
      </div>
      <!-- 跑马灯 -->
      <Swiper :piclist="piclist" />
    </div>
    <!-- 登录注册 -->
    <van-popup
      v-model="contShow"
      :style="{ minHeight: '42%', minWidth: '300px', borderRadius: '3%' }"
    >
      <div class="content">
        <!-- 手机快捷登录 -->
        <div class="login phone-quick-login" v-show="phoneShow">
          <p class="title">手机快捷登录</p>
          <div class="account">
            <i class="icon i-phone"></i>
            <input type="number" placeholder="请输入手机号" v-model="phone" />
          </div>
          <div class="code">
            <i class="icon i-yzm"></i>
            <input type="text" placeholder="请输入验证码" v-model="code" />
            <button
              @click="landingGetCode('quick_login', phone)"
              class="code-btn"
              :disabled="!codeShow"
            >
              <span v-show="codeShow">获取验证码</span>
              <span v-show="!codeShow" class="count">{{ count }} s</span>
            </button>
          </div>
          <div class="confirm loginBtn" @click="phoneQuickLogin">登录</div>
          <div class="tool quick-tool">
            <span @click="onShow('quickReg')">一键注册</span>
            <span>|</span>
            <span @click="onShow('phoneRegister')">手机注册</span>
            <span>|</span>
            <span @click="onShow('accountLogin')">账号登录</span>
          </div>
        </div>
        <!-- 账号登录 -->
        <div class="userAccount account-login" v-show="accountShow">
          <p class="title">账号登录</p>
          <div class="account">
            <i class="icon i-account"></i>
            <input
              type="text"
              placeholder="请输入账号/手机号码"
              v-model="userAccount"
            />
          </div>
          <div class="password">
            <i class="icon i-psd"></i>
            <input type="password" placeholder="请输入密码" v-model="userPsd" />
          </div>
          <div class="confirm loginBtn" @click="accountLogin">登录</div>
          <div class="tool quick-tool">
            <span @click="onShow('quickReg')">注册账号</span>
            <span>|</span>
            <span @click="onShow('phoneLogin')">手机快捷登录</span>
            <span>|</span>
            <span @click="onShow('findPsd')">忘记密码</span>
          </div>
        </div>
        <!-- 手机号注册 -->
        <div class="register phoneReg" v-show="phoneRegShow">
          <p class="title">
            <i class="icon i-back" @click="onBack('phoneReg')"></i>
            <span>手机号注册</span>
          </p>
          <div class="account">
            <i class="icon i-account"></i>
            <input
              type="number"
              placeholder="请输入手机号码"
              v-model="regPhone"
            />
          </div>
          <div class="password">
            <i class="icon i-psd"></i>
            <input type="password" placeholder="请输入密码" v-model="regPsd" />
          </div>
          <div class="code">
            <i class="icon i-yzm"></i>
            <input type="text" placeholder="请输入验证码" v-model="regCode" />
            <button
              @click.prevent="landingGetCode('reg', regPhone)"
              class="code-btn"
              :disabled="!codeShow"
            >
              <span v-show="codeShow">获取验证码</span>
              <span v-show="!codeShow" class="count">{{ count }} s</span>
            </button>
          </div>
          <div class="confirm" @click="phoneReg">注册</div>
        </div>
        <!-- 一键注册 -->
        <div class="register quickReg" v-show="quickRegShow">
          <p class="title">
            <i class="icon i-back" @click="onBack('quickReg')"></i>
            <span>一键注册</span>
          </p>
          <div class="account">
            <i class="icon i-account"></i>
            <input
              type="text"
              placeholder="请输入账号"
              v-model="quickRegAccount"
            />
          </div>
          <div class="password">
            <i class="icon i-psd"></i>
            <input
              type="password"
              placeholder="请输入密码"
              v-model="quickRegPsd"
            />
          </div>
          <div class="confirm" @click="qucikAccountReg">注册</div>
        </div>
        <!-- 忘记密码 -->
        <div class="findPsd" v-show="findPsdShow">
          <p class="title">
            <i class="icon i-back" @click="onBack('quickReg')"></i>
            <span>忘记密码</span>
          </p>
          <div class="account">
            <i class="icon i-account"></i>
            <input
              type="number"
              placeholder="请输入手机号"
              v-model="findPhone"
            />
          </div>
          <div class="password">
            <i class="icon i-psd"></i>
            <input
              type="password"
              placeholder="请输入新密码"
              v-model="findPsd"
            />
          </div>
          <div class="code">
            <i class="icon i-yzm"></i>
            <input type="text" placeholder="请输入验证码" v-model="findCode" />
            <button
              @click.prevent="landingGetCode('findpwd', findPhone)"
              class="code-btn"
              :disabled="!codeShow"
            >
              <span v-show="codeShow">获取验证码</span>
              <span v-show="!codeShow" class="count">{{ count }} s</span>
            </button>
          </div>
          <div class="confirm" @click="findPassword">确认</div>
        </div>
        <!-- 选择子账号 -->
        <div class="select-sub-account" v-show="subAccountShow">
          <p class="title">
            <i class="icon i-back" @click="onBack('select')"></i>
            <span>选择子账号</span>
          </p>
          <div class="account">
            <i class="icon i-account"></i>
            <input type="number" disabled :placeholder="account" />
            <i
              class="icon i-select"
              @click="accountListShow = !accountListShow"
            ></i>
          </div>
          <div class="accountList" v-show="accountListShow">
            <p
              class="list"
              v-for="(item, index) in accountList"
              :key="index"
              @click="selectList(item)"
            >
              <span>{{ item.uname }}</span>
            </p>
          </div>
          <div class="confirm" @click="childAccount()">确定</div>
          <div class="confirm create" @click="onShow('create')">创建子账号</div>
        </div>
        <!-- 自定义子账号 -->
        <div class="custom-child-account" v-show="childAccountShow">
          <p class="title">
            <i class="icon i-back" @click="onBack('create')"></i>
            <span>创建子账号</span>
          </p>
          <div class="account">
            <i class="icon i-account"></i>
            <input type="text" placeholder="请输入账号" v-model="subAccount" />
          </div>
          <div class="password">
            <i class="icon i-psd"></i>
            <input type="password" placeholder="请输入密码" v-model="subPsd" />
          </div>
          <div class="confirm loginBtn" @click="addSubAccount">确定</div>
        </div>
        <!-- 手机绑定 -->
        <div class="bind bind-phone" v-show="bindShow">
          <p class="title">绑定手机</p>
          <div class="account">
            <i class="icon i-phone"></i>
            <input
              type="number"
              placeholder="请输入手机号"
              v-model="bindPhone"
            />
          </div>
          <div class="code">
            <i class="icon i-yzm"></i>
            <input type="text" placeholder="请输入验证码" v-model="bindCode" />
            <button
              @click="landingGetCode('bind', bindPhone)"
              class="code-btn"
              :disabled="!codeShow"
            >
              <span v-show="codeShow">获取验证码</span>
              <span v-show="!codeShow" class="count">{{ count }} s</span>
            </button>
          </div>
          <div class="confirm bindPhone" @click="onBindPhone">确认</div>
        </div>
      </div>
    </van-popup>
    <!-- 微信过渡页 -->
    <wxTransition v-show="isWeixinWeb" />
  </div>
</template>

<script>
import apiFun from "../servers/independent-module/apiFun";
// import data from "../assets/json/data.json";
import { lyTool, contTools } from "../mixins/contMixins";
import comTools from "@/assets/js/until";
import Swiper from "../components/content/user-center/swiper";
import wxTransition from "../components/content/user-center/wxTransition";
export default {
  name: "clientLanding",
  mixins: [lyTool, contTools],
  components: {
    Swiper,
    wxTransition,
  },
  data() {
    return {
      isPcDown: "", // pc显示落地页
      gameData: [],
      piclist: [],
      btn_list: [], // 显示按钮列表
      urlData: this.$route.query, // 获取地址栏信息
      sysPid: "", // 系统端游戏Pid
      comData: {}, // 公共参数
      token: "",
      uname: "", // 子账号
      phone: "", // 手机号1
      mobile: sessionStorage.getItem("mobile") || "", // 绑定手机号
      code: "", // 验证码1
      codeShow: true,
      count: "",
      timer: "",
      isLogin: sessionStorage.getItem("access_token") || "",

      userAccount: "", // 账号登录-账号
      userPsd: "", // 账号登录-密码

      quickRegAccount: "", // 快速注册-账号
      quickRegPsd: "", // 快速注册-密码

      regPsd: "", // 手机号注册-密码
      regPhone: "", // 手机号注册-手机
      regCode: "", // 手机号注册-验证码

      findPhone: "", // 找回密码-手机号
      findPsd: "", // 找回密码-密码
      findCode: "", // 找回密码-验证码

      subAccount: "", // 自定义账号-账号
      subPsd: "", // 自定义账号-密码

      bindPhone: "", // 绑定手机
      bindCode: "", // 绑定手机的
      contShow: false, // 弹窗
      isWeixinWeb: false, // 是否微信环境
      platform: true, // 是否多平台
      phoneShow: true, // 手机号登录
      accountShow: false, // 账号登录
      phoneRegShow: false, // 手机号注册
      quickRegShow: false, // 一键注册
      findPsdShow: false, // 忘记密码
      subAccountShow: false, // 选择子账号
      childAccountShow: false, // 创建子账号
      bindShow: false, // 绑定手机号
      showOptions: {
        phoneShow: false,
        accountShow: false,
        phoneRegShow: false,
        quickRegShow: false,
        findPsdShow: false,
        subAccountShow: false,
        childAccountShow: false,
        bindShow: false,
      },
      account: "", // 选定子账号
      accountListShow: false, // 子账号列表显示

      accountList: [], // 子账号列表
    };
  },
  created() {
    this.isWeixin();
    this.landingData();
    this.comData = {
      client: "h5",
      client_id: this.getIdfa(),
      mid: this.urlData.glMid || 10000,
      p_mid: this.urlData.glPMid,
      tm: this.getTm(),
    };
    this.initView();
    // console.log("urlData", this.comData);
  },
  computed: {
    iosSystem: function() {
      console.log(this.isIos());
      return this.isIos();
    },
    androidSystem: function() {
      return this.isAndroid();
    },
  },
  methods: {
    onShow(type) {
      this.closeContainer(type);
    },
    // 锚点滚动
    jumpDownGame() {
      // this.$nextTick(() => {
      //   let _offsetTop = this.$refs.downGame.offsetTop;
      //   document.documentElement.scrollTop =
      //     this.$refs.downGame.offsetTop - 100;
      //   // console.log("downGame", this.$refs.downGame.offsetTop);
      // });

    },
    // 返回一级页面
    onBack(type) {
      switch (true) {
        case type == "create":
          this.phoneShow = false;
          this.accountShow = false;
          this.phoneRegShow = false;
          this.quickRegShow = false;
          this.findPsdShow = false;
          this.subAccountShow = true;
          this.childAccountShow = false;
          break;
        default:
          this.phoneShow = true;
          this.accountShow = false;
          this.phoneRegShow = false;
          this.quickRegShow = false;
          this.findPsdShow = false;
          this.subAccountShow = false;
          this.childAccountShow = false;
          break;
      }
    },
    // 选择子账号
    selectList(item) {
      this.accountListShow = false;
      this.account = item.uname;
      this.token = item.access_token;
    },
    // 登录
    login(type) {
      switch (true) {
        case type == "account":
          this.onShow("sub");
          break;

        default:
          break;
      }
    },
    // 手机号注册
    phoneReg() {
      let data = comTools.assignObj(
        {
          mobile: this.regPhone,
          password: this.getMd5(this.regPsd),
          code: this.regCode,
        },
        this.comData
      );
      // console.log(this.querySort(data));
      data.sign = this.querySort(data);
      // this.$md5(data);
      apiFun.phoneReg(data).then((res) => {
        if (res.code === 200) {
          this.accountList = res.data.user_list;
          this.account = this.accountList[0].uname;
          this.token = this.accountList[0].access_token;
          this.onShow("sub");
        } else {
          this.$toast({ message: res.msg });
        }
      });
    },
    // 快捷登录
    phoneQuickLogin() {
      let data = comTools.assignObj(
        {
          mobile: this.phone,
          code: this.code,
        },
        this.comData
      );
      // console.log(this.querySort(data));
      data.sign = this.querySort(data);
      apiFun.phoneFastLogin(data).then((res) => {
        if (res.code === 200) {
          this.accountList = res.data.user_list;
          this.account = this.accountList[0].uname;
          this.token = this.accountList[0].access_token;
          this.onShow("sub");
        } else {
          this.$toast({ message: res.msg });
        }
      });
    },

    // 账号登录
    accountLogin() {
      let data = comTools.assignObj(
        {
          uname: this.userAccount,
          password: this.getMd5(this.userPsd),
        },
        this.comData
      );
      // console.log(this.querySort(data));
      data.sign = this.querySort(data);
      apiFun.accountLogin(data).then((res) => {
        if (res.code === 200) {
          this.accountList = res.data.user_list;
          if (this.accountList != undefined) {
            this.account = this.accountList[0].uname;
            this.token = this.accountList[0].access_token;
            this.onShow("sub");
          } else {
            this.$toast({ message: res.msg });
            this.onShow();
            this.setSession("access_token", res.data.access_token);
            this.setSession("uname", res.data.uname);
            this.setSession("mobile", res.data.bind_info.mobile);
            this.mobile = res.data.bind_info.mobile;
            this.isLogin = res.data.access_token;
            this.mobile = res.data.bind_info.mobile;
            this.contShow = false;
          }
        } else {
          this.$toast({ message: res.msg });
        }
      });
    },

    // 选择子账号登录
    childAccount() {
      let data = comTools.assignObj(
        {
          uname: this.account,
          access_token: this.token,
        },
        this.comData
      );
      data.sign = this.querySort(data);
      apiFun.childAccount(data).then((res) => {
        if (res.code === 200) {
          this.contShow = false;
          this.onShow();
          this.setSession("access_token", res.data.access_token);
          this.setSession("uname", res.data.uname);
          this.setSession("mobile", res.data.vname);
          this.isLogin = res.data.access_token;
          this.mobile = res.data.vname;
        } else {
          this.$toast({ message: res.msg });
        }
      });
    },

    // 一键注册
    qucikAccountReg() {
      let data = comTools.assignObj(
        {
          uname: this.quickRegAccount,
          password: this.getMd5(this.quickRegPsd),
        },
        this.comData
      );
      // console.log(this.querySort(data));
      data.sign = this.querySort(data);
      apiFun.accountFastLogin(data).then((res) => {
        if (res.code === 200) {
          this.setSession("access_token", res.data.access_token);
          this.setSession("uname", res.data.uname);
          this.setSession("mobile", res.data.bind_info.mobile);
          this.isLogin = res.data.access_token;
          this.mobile = res.data.bind_info.mobile;
          this.$toast({ message: res.msg });
          this.onShow("bind");
          // this.onShow();
          // this.contShow = false;
        } else {
          this.$toast({ message: res.msg });
        }
      });
    },

    // 找回密码
    findPassword() {
      let _data = comTools.assignObj({}, this.comData);
      delete _data.p_mid;
      delete _data.client_id;
      let data = comTools.assignObj(
        {
          mobile: this.findPhone,
          uname: this.findPhone,
          new_pwd: this.getMd5(this.findPsd),
          code: this.findCode,
          type: "findpwd",
        },
        _data
      );
      // console.log(this.querySort(data));
      data.sign = this.querySort(data);
      // this.$md5(data);
      apiFun.findPassWord(data).then((res) => {
        if (res.code === 200) {
          this.onShow("phoneLogin");
          this.codeShow = true;
          this.$toast({ message: res.msg });
        } else {
          this.$toast({ message: res.msg });
        }
      });
    },

    // 创建子账号
    addSubAccount() {
      let data = comTools.assignObj(
        {
          mobile: sessionStorage.getItem("appland_mobile"),
          uname: this.subAccount,
          password: this.getMd5(this.subPsd),
        },
        this.comData
      );
      // console.log(this.querySort(data));
      data.sign = this.querySort(data);
      // this.$md5(data);
      apiFun.addSubAccount(data).then((res) => {
        if (res.code === 200) {
          this.accountLogin();
          this.$toast({ message: res.msg });
        } else {
          this.$toast({ message: res.msg });
        }
      });
    },

    // 绑定手机号
    onBindPhone() {
      let _data = comTools.assignObj({}, this.comData);
      delete _data.client_id;
      let data = comTools.assignObj(
        {
          access_token: sessionStorage.getItem("access_token"),
          mobile: this.bindPhone,
          new_mobile: this.bindPhone,
          uname: sessionStorage.getItem("uname"),
          code: this.bindCode,
        },
        _data
      );
      data.sign = this.querySort(data);
      // this.setSession("mobile", res.data);
      // this.$cookies.set("mobile", true);
      apiFun.bindMobile(data).then((res) => {
        if (res.code === 200) {
          console.log(res, "--res");
          this.mobile = res.data;
          this.setSession("mobile", res.data);
          this.$toast({ message: res.msg });
          this.onShow();
        } else {
          this.$toast({ message: res.msg });
        }
      });
    },

    // 落地页数据
    landingData() {
      let data = {
        p_gid: this.urlData.glPGid,
        gid: this.urlData.glGid,
        p_mid: this.urlData.glPMid,
      };
      data.sign = this.querySort(data);
      apiFun.landing(data).then((res) => {
        if (res.code == 200) {
          this.gameData = res.data;
          this.piclist = this.gameData.banners;
          this.btn_list = this.gameData.btn_list;
          // console.log(this.gameData);
        }
      });
    },

    // 获取短信验证码
    landingGetCode(type, targetPhone) {
      let data = {
        mobile: targetPhone,
        type: type,
        client: "h5",
        pid: this.urlData.glPid,
        gid: this.urlData.glGid,
        mid: this.urlData.glMid || 10000,
        tm: this.getTm(),
      };
      if (this.inputCheck(targetPhone, "phone")) {
        if (type == "bind") {
          let _data = data;
          _data.access_token = sessionStorage.getItem("access_token");
          _data.sign = this.querySort(_data);
          apiFun.getYzm(_data).then((res) => {
            if (res.code === 200) {
              // this.code = res.data.vcode;
              if (!this.timer) {
                // 验证码倒计时
                this.count = 60;
                this.codeShow = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= 60) {
                    this.count--;
                  } else {
                    this.codeShow = true;
                    clearInterval(this.timer);
                    this.timer = null;
                    this.code = "";
                  }
                }, 1000);
              }
              this.$toast({
                message: res.msg,
                duration: 2000,
              });
            } else {
              this.$toast({
                message: res.msg,
                duration: 2000,
              });
            }
          });
        } else {
          data.sign = this.querySort(data);
          apiFun.getYzm(data).then((res) => {
            if (res.code === 200) {
              // this.code = res.data.vcode;
              if (!this.timer) {
                // 验证码倒计时
                this.count = 60;
                this.codeShow = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= 60) {
                    this.count--;
                  } else {
                    this.codeShow = true;
                    clearInterval(this.timer);
                    this.timer = null;
                    this.code = "";
                  }
                }, 1000);
              }
              this.$toast({
                message: res.msg,
                duration: 2000,
              });
            } else {
              this.$toast({
                message: res.msg,
                duration: 2000,
              });
            }
          });
        }
      }
    },

    // 本地存储
    setSession(name, value) {
      console.log("萨达");
      sessionStorage.setItem(name, value);
    },

    // 关闭其他容器
    closeContainer(type) {
      let showTypeMap = new Map();
      showTypeMap.set("phoneLogin", "phoneShow");
      showTypeMap.set("accountLogin", "accountShow");
      showTypeMap.set("phoneRegister", "phoneRegShow");
      showTypeMap.set("quickReg", "quickRegShow");
      showTypeMap.set("findPsd", "findPsdShow");
      showTypeMap.set("sub", "subAccountShow");
      showTypeMap.set("create", "childAccountShow");
      showTypeMap.set("bind", "bindShow");
      if (type) {
        this.showOptions[showTypeMap.get(type)] = true;
        console.log(this.showOptions, "--this.showOptions");
        for (let [k, v] of Object.entries(this.showOptions)) {
          this.showOptions[k] = false;
          this[k] = v;
        }
      } else {
        console.log(type, "--!type");
        this.contShow = false;
      }
      // this.findPsdShow = false;
      // this.quickRegShow = false;
      // this.phoneRegShow = false;
      // this.phoneShow = false;
      // this.accountShow = false;
      // this.subAccountShow = false;
      // this.childAccountShow = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/com.less";
.clientLanding {
  width: 100%;
  // height: 100%;
  .topBar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    z-index:  100;
    padding: 0.1rem 0;
    display: flex;
    justify-content: space-between;
    .barL {
      width: 70%;
      display: flex;
      align-items: center;
      .barIcon {
        width: 2rem;
        padding: 0.2rem 0;
        padding-bottom: 0.1rem;
        padding-left: 0.3rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .bartitle {
        color: #fff;
        padding-left: 0.3rem;
        p {
          &:nth-of-type(1) {
            margin-bottom: 0.1rem;
          }
          &:nth-of-type(2) {
            font-size: 0.4rem;
          }
        }
      }
    }
    .barR {
      display: flex;
      align-items: center;
      margin-right: 0.2rem;
      p {
        display: block;
        width: 24.2667vw;
        height: 9.8667vw;
        background: url('../assets/image/down.gif');
        background-size: 24.2667vw 9.8667vw;
        background-repeat: no-repeat;
        a {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .bg-img {
    position: relative;
    width: 100%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
    .downGame {
      width: 100%;
      // height: 2.5rem;
      // background-color: #fff;
      position: absolute;
      left: 50%;
      top: 18.5rem;
      transform: translate(-50%);
      display: flex;
      justify-content: space-around;
      .system {
        width: 4rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .pcDownGame {
      top: 19.5rem;
    }
  }
  .content {
    // position: absolute;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%, -50%);
    width: 100%;
    .login,
    .userAccount,
    .bind-phone,
    .register,
    .findPsd,
    .select-sub-account,
    .custom-child-account {
      padding: 0 0.5rem;
      .account,
      .code,
      .password {
        min-height: 1.2rem;
        .theme-bd-color();
        .borderRadius();
        margin-bottom: 0.3rem;
        .jc-content(initial);
        input {
          // color: #000;
          // padding: 0.3rem 0;
        }
        .icon {
          // background-color: #ddd;
          display: inline-block;
          margin-left: 0.2rem;
          margin-right: 0.1rem;
        }
      }
      .tool {
        .jc-around();
        .font-color();
      }
      .title {
        text-align: center;
        padding: 0.5rem 0;
        position: relative;
        .icon {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translate(0, -50%);
          // background-color: #ddd;
          display: inline-block;
        }
      }
      .confirm {
        width: 100%;
        min-height: 1.2rem;
        line-height: 1.2rem;
        text-align: center;
        color: #fff;
        margin-bottom: 0.3rem;
        .theme-bg-color();
        .borderRadius();
      }
      .code {
        .jc-between();
        input {
          width: 50%;
        }
        .code-btn {
          background-color: #ff971c;
          border-radius: 20px;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          color: #fff;
          font-size: 0.4rem;
          width: 30%;
          min-height: 1.2rem;
          span {
            height: 100%;
          }
        }
      }
    }
    .select-sub-account {
      position: relative;
      .account {
        position: relative;
        .i-select {
          position: absolute;
          right: 0.5rem;
          top: 50%;
          transform: translate(0, -50%);
        }
      }
      .accountList {
        position: absolute;
        left: 50%;
        top: 49%;
        transform: translate(-50%, 0);
        width: 78%;
        height: 5rem;
        border: 1px solid #ddd;
        border-top: none;
        overflow-y: scroll;
        background-color: #fff;
        p {
          padding: 0.2rem 0;
          border-bottom: 1px solid #ddd;
          &:last-child {
            border-bottom: none;
          }
          span {
            padding-left: 0.5rem;
          }
        }
      }
    }
  }
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    text-align: center;
    // opacity: .5;
    .maskTipImg {
      width: 80%;
      height: auto;
      margin-left: 1rem;
    }
  }
  .i-phone {
    width: 1rem;
    height: 1rem;
    background: url("~@assets/image/independent/i-phone.png") no-repeat center;
    background-size: 100% 100%;
  }
  .i-yzm {
    width: 1rem;
    height: 1rem;
    background: url("~@assets/image/independent/i-yzm.png") no-repeat center;
    background-size: 100% 100%;
  }
  .i-account {
    width: 1rem;
    height: 1rem;
    background: url("~@assets/image/independent/i-account.png") no-repeat center;
    background-size: 100% 100%;
  }
  .i-psd {
    width: 1rem;
    height: 1rem;
    background: url("~@assets/image/independent/i-psd.png") no-repeat center;
    background-size: 100% 100%;
  }
  .i-back {
    width: 0.5rem;
    height: 0.5rem;
    background: url("~@assets/image/independent/i-back.png") no-repeat center;
    background-size: 100% 100%;
  }
  .i-select {
    width: 0.5rem;
    height: 0.5rem;
    background: url("~@assets/image/independent/i-select.png") no-repeat center;
    background-size: 100% 100%;
  }
}
</style>
